import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Alert } from 'react-bootstrap'
import styled from 'styled-components'
import OverlayRight from '../../Page/logix2020/OverlayRight'
import OverlayContainer from '../../Page/logix2020/OverlayContainer'
import useCabinTypesState from '../../../stores/Configuration/useCabinTypesState'
import LanguageForm from '../../Forms/LanguageForm'
import LanguageNameInput from '../../Forms/LanguageNameInput'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'

const StyledDiv = styled.div`
  width: 600px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  .alert {
    margin-top: 1.5rem;
  }
`

const CabinTypesGeneralForm = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [overlayVisible, setOverlayVisible] = useState(false)
  const {
    handleSubmit,
    error,
    formErrors,
    success,
    selectedCabinType,
    setSelectedCabinType,
    redirectId,
    setSuccess,
    setError,
  } = useCabinTypesState()

  useEffect(() => {
    setError('')
    setSuccess('')

    if (formErrors?.name) {
      formErrors.name = undefined
    }
    setSelectedCabinType((prev) => ({
      ...prev,
      name: { values: [] },
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash])

  const handleCloseOverlay = () => {
    setOverlayVisible(false)
  }

  useEffect(() => {
    if (location.state?.created) {
      setSuccess(t('registrationBox:savingSuccess'))
      navigate(location.pathname + location.hash, { replace: true })
    }
  }, [
    location.state,
    setSuccess,
    t,
    navigate,
    location.pathname,
    location.hash,
  ])

  const updateNames = (translations) => {
    setSelectedCabinType((prev) => ({
      ...prev,
      name: {
        values: translations,
      },
    }))
  }

  //redirect to edit page after new type was created
  if (redirectId) {
    return (
      <Navigate
        to={`/cabinTypes/edit/${redirectId}#general`}
        state={{ created: true }}
        replace
      />
    )
  }

  return (
    <StyledDiv>
      <LanguageNameInput
        openLanguageModal={() => setOverlayVisible(true)}
        languageArray={
          (selectedCabinType.name && selectedCabinType.name.values) || []
        }
        onChange={(translations) => {
          setError('')
          setSuccess('')
          if (formErrors?.name) {
            formErrors.name = undefined
          }
          updateNames(translations)
        }}
        label={t('name')}
        isInvalid={formErrors && formErrors.name}
      />
      {success && (
        <Alert variant='success' className='mt-2'>
          {success}
        </Alert>
      )}
      {(error || formErrors?.name) && (
        <Alert variant='danger'>{error || formErrors.name}</Alert>
      )}
      <Button onClick={() => handleSubmit('general')}>{t('saveButton')}</Button>
      <OverlayContainer>
        <OverlayRight visible={overlayVisible} onClose={handleCloseOverlay}>
          <LanguageForm
            languageTitle='Cabin'
            handleCloseOverlay={handleCloseOverlay}
            languageArray={
              (selectedCabinType.name && selectedCabinType.name.values) || []
            }
            onChange={updateNames}
          />
        </OverlayRight>
      </OverlayContainer>
    </StyledDiv>
  )
}

export default observer(CabinTypesGeneralForm)
